import type { SerializedStyles } from '@emotion/serialize'
import * as React from 'react'

import S from './StatusButtonFactory.style'

type Props<statusName> = {
  statusName: statusName
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

export type FactoryArg<T extends string> = {
  [statusName in T]: {
    text: string
    css: {
      button: SerializedStyles
      text: SerializedStyles
    }
  }
}

export function StatusButtonFactory<argT extends FactoryArg<string>>(arg: argT) {
  return function StatusButton({ statusName, onClick }: Props<keyof argT>) {
    const { text, css } = arg[statusName]

    return (
      <button css={[S.basic, css.button]} onClick={onClick}>
        <span css={[S.text, css.text]}>{text}</span>
      </button>
    )
  }
}
